import { render, staticRenderFns } from "./InvitationTable.vue?vue&type=template&id=248be742&"
import script from "./InvitationTable.vue?vue&type=script&lang=js&"
export * from "./InvitationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports